module.exports = __webpack_public_path__ + "static/media/zerog.16dde79a.png";